"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
require("./sis-paging.component.css");
var Paging = /** @class */ (function () {
    function Paging() {
        this._totalPageCount = 0;
        this._page = 0;
        this._pageSize = 0;
        this._pages = [];
        this.firstItemPlaceholder = 'first';
        this.lastItemPlaceholder = 'last';
        this.totalPlaceholder = 'total';
        this._defaultNumbersPerPage = [10, 25, 50, 100, 200];
        this.itemsNumbersPerPage = [];
        this.showFirstLastButtons = true;
        /**
         * @deprecated - For backward compatibility only.
         * This property is for paging component 'of' label.
         */
        this.outOfLabel = "of";
        this.message = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " - ", " of ", ""], ["", " - ", " of ", ""])), this.firstItemPlaceholder, this.lastItemPlaceholder, this.totalPlaceholder);
        this.pageChange = new core_1.EventEmitter();
        this.pageSizeChange = new core_1.EventEmitter();
        this.itemsPerPageMessage = 'Items per page:';
        this.isItemsPerPageSelectEnabled = false;
    }
    Object.defineProperty(Paging.prototype, "totalPageCount", {
        get: function () {
            return this._totalPageCount;
        },
        set: function (totalPageCount) {
            this._totalPageCount = totalPageCount;
            this._initPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (page) {
            this._page = page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (pageSize) {
            this._pageSize = pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "itemsCount", {
        get: function () {
            return this._itemsCount;
        },
        set: function (itemsCount) {
            this._itemsCount = itemsCount;
            if (this.isItemsPerPageSelectEnabled) {
                this.initItemsNumbersPerPage();
            }
        },
        enumerable: true,
        configurable: true
    });
    Paging.prototype.changePage = function (page) {
        this._page = page;
        this.pageChange.emit(this._page);
    };
    Object.defineProperty(Paging.prototype, "pages", {
        get: function () {
            return this._pages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "firstItemIndex", {
        get: function () {
            return this._itemsCount !== 0 ? this._page * this._pageSize + 1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "lastItemIndex", {
        get: function () {
            return this._itemsCount === 0 ? 0
                : (this._page !== this._pages[this._pages.length - 1] ? (this._page + 1) * this._pageSize : this._itemsCount);
        },
        enumerable: true,
        configurable: true
    });
    Paging.prototype._initPages = function () {
        this._pages = [];
        for (var i = 0; i < this._totalPageCount; i++) {
            this._pages.push(i);
        }
    };
    Paging.prototype.changePageSize = function (pageSize) {
        this._page = Math.floor(this._page * this._pageSize / pageSize);
        this._pageSize = pageSize;
        var totalPageCount = this._itemsCount / this._pageSize;
        this.totalPageCount = Math.ceil(totalPageCount);
        this.pageSizeChange.emit(pageSize);
        this.pageChange.emit(this._page);
    };
    Paging.prototype.initItemsNumbersPerPage = function () {
        var _this = this;
        var itemsPerPageArray = this.defaultItemsNumbersPerPage ? this.defaultItemsNumbersPerPage : this._defaultNumbersPerPage;
        this.itemsNumbersPerPage = itemsPerPageArray.filter(function (itemsCountPerPage) {
            return itemsCountPerPage <= _this._itemsCount;
        });
        if (this.itemsNumbersPerPage.length == 0 && this.itemsCount !== 0) {
            this.itemsNumbersPerPage.push(this.itemsCount);
            this.changePageSize(this.itemsCount);
        }
        if (this.itemsCount !== 0 && this.itemsNumbersPerPage.indexOf(this._pageSize) < 0) {
            this.changePageSize(this.itemsNumbersPerPage[0]);
        }
    };
    Paging.prototype.ngOnInit = function () {
        if (this.isItemsPerPageSelectEnabled) {
            this.initItemsNumbersPerPage();
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], Paging.prototype, "defaultItemsNumbersPerPage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Paging.prototype, "showFirstLastButtons", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Paging.prototype, "outOfLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_common_util_frontend_1.StringTemplate)
    ], Paging.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], Paging.prototype, "totalPageCount", null);
    __decorate([
        core_1.Input('page'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], Paging.prototype, "page", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Paging.prototype, "pageChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], Paging.prototype, "pageSize", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Paging.prototype, "pageSizeChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], Paging.prototype, "itemsCount", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Paging.prototype, "itemsPerPageMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Paging.prototype, "isItemsPerPageSelectEnabled", void 0);
    Paging = __decorate([
        core_1.Component({
            
            selector: 'sis-paging',
            template: require('./sis-paging.component.html')
        })
    ], Paging);
    return Paging;
}());
exports.Paging = Paging;
var templateObject_1;
//# sourceMappingURL=sis-paging.component.js.map